export default __webpack_public_path__ + "media/images/service_instructor-92ee04380d10a73fa482d6382a39f1a8.jpg";